import GoRoundMain from "./go-aroung/goAroundMain";



export const WebRoutes=[
    {path:'/showqr/:token', component:<GoRoundMain/>, exact: true}
    // {path:'/downloadqr/:token', component:<DownloadQrCodeUrl/>, exact: true},
    // {path: '/readqr', component: <ReadQR/>, exact: true},
    // {path:'/showreceipt/:token', component: <ShowReceipt/>, exact: true},
    //  {path: '/video', component: <Videos/>, exact: true}
]
